"use client"

import { useEffect, useRef } from "react"
import { createPortal } from "react-dom"

export function ToastPortal({ children }: { children: React.ReactNode }) {
  const elRef = useRef<HTMLDivElement | null>(null)
  
  if (!elRef.current && typeof document !== 'undefined') {
    elRef.current = document.createElement("div")
  }

  useEffect(() => {
    const el = elRef.current
    if (!el) return
    
    el.id = "quiz-toast-root"
    el.style.position = "fixed"
    el.style.left = "50%"
    el.style.top = "20px"
    el.style.transform = "translateX(-50%)"
    el.style.zIndex = "9999"
    el.style.pointerEvents = "none"
    el.style.paddingTop = "env(safe-area-inset-top, 0)"
    
    document.body.appendChild(el)
    
    return () => {
      if (document.body.contains(el)) {
        document.body.removeChild(el)
      }
    }
  }, [])

  if (!elRef.current) return null

  return createPortal(children, elRef.current)
}

